export default "__VITE_ASSET__5DGKFuOu__"